import React from "react"
import PropTypes from "prop-types"
import { connect }  from 'react-redux'

import VisitProducts from "./VisitProducts.js"

class VisitSubforms extends React.Component {
  render = () => {
    const visitTypeOptions = this.props.visitTypes.map(opt => <option key={opt.id} value={opt.id} > {opt.name} </option>)
    const paymentTypeOptions = this.props.paymentTypes.map(opt => <option key={opt.id} value={opt.id} > {opt.name} </option>)
    return (
      <React.Fragment>
        <div className="field col-xs-12 col-sm-6">
          <label htmlFor="visit[visit_type_id]">Τύπος Επίσκεψης</label>
          <select
            id="visit_visit_type_id"
            className="form-control"
            name="visit[visit_type_id]"
            value={this.props.selectedVisitType.id}
            onChange={this.props.changeVisitTypeSelection}
          >
            {visitTypeOptions}
          </select>
        </div>
        <VisitProducts />
        <div className="form-group col-sm-3">
          <label htmlFor="visit[amount]">Ποσό</label>
          <input disabled id="amount" className="form-control" type="number" step="0.01" value={this.props.totalValue} name="visit[amount]" />
        </div>
        <div className="form-group col-sm-3">
          <label htmlFor="visit_visit_type">Τύπος Πληρωμής</label>
          <select
            id="visit_payment_type_id"
            className="form-control"
            name="visit[payment_type_id]"
            value={this.props.selectedPaymentType}
            onChange={this.props.changePaymentTypeSelection}>
            <option value=""></option>
            {paymentTypeOptions}
          </select>
        </div>
      </React.Fragment>
    );
  }
}

const mapState = state => {
  return {
    totalValue: state.totalValue,
    visitTypes: state.visitTypes,
    selectedVisitType: state.selectedVisitType,
    paymentTypes: state.paymentTypes,
    selectedPaymentType: state.selectedPaymentType
  }
}

const mapDispatch = dispatch => {
  return {
    changeVisitTypeSelection: (event) => dispatch({type: 'CHANGE_VISIT_TYPE', selectedVisitType: event.target.value}),
    changePaymentTypeSelection: (event) => dispatch({type: 'CHANGE_PAYMENT_TYPE', selectedPaymentType: event.target.value})
  }
}

export default connect(mapState, mapDispatch)(VisitSubforms)
